import { Dialog, DialogProps } from '@economic/taco';
import React from 'react';
import { t } from '@lingui/macro';
import * as types from '../../../../../../types/internal-api';
import ProductCollectionForm from '../../../../../forms/Setup/ProductCollections/ProductCollectionForm';
import useQuery from '../../../../../shared/hooks/useQuery';
import Loader from '../../../../../shared/components/Loader';
import internalApiClient from '../../../../../shared/util/api/internalApiClient';

type Props = Partial<DialogProps> & {
    onHide: () => void;
    refetch: () => void;
    productCollectionId: number;
};

export function CopyProductCollectionDialog(props: Props) {
    const nextIdQuery = useQuery<number>(`/products/product-collections/get-next-available-id`);
    const productCollectionQuery = useQuery<types.ProductCollectionModel>(
        `/products/product-collections/${props.productCollectionId}`
    );

    async function create(values: types.ProductCollectionModel) {
        await internalApiClient.post(`products/product-collections/${props.productCollectionId}`, values);
        props.onHide();
        props.refetch();
    }

    if (nextIdQuery.loading || productCollectionQuery.loading) {
        return <Loader />;
    }

    return (
        <>
            <Dialog.Title>{t`Product collection`}</Dialog.Title>
            <ProductCollectionForm
                initialValue={{ id: nextIdQuery.data, name: productCollectionQuery.data.name }}
                onCreate={create}
                showSaveAndNewButton={false}
                disableId={false}
            />
        </>
    );
}
